export const CLASSIFICATIONS_SAMPLING_COLORS = [
  '#1976D2', // Blue
  '#D500F9', // Purple
  '#651FFF', // Indigo
  '#2E7D32', // Green
  '#2355de', // Dark Blue
  '#EC407A', // Pink
  '#00B8D4', // Teal
  '#AA00FF', // Violet
] as const;

/** Unclassified sampling notes: neutral gray (not part of the classification palette). */
export const DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR = '#9E9E9E';

export function buildClassificationColorMap(
  classifications: Array<{ id: number }>
): Record<number, string> {
  return (classifications || []).reduce((acc, c, index) => {
    if (c && c.id != null) {
      acc[c.id] =
        CLASSIFICATIONS_SAMPLING_COLORS[index % CLASSIFICATIONS_SAMPLING_COLORS.length];
    }
    return acc;
  }, {} as Record<number, string>);
}

export function resolveSamplingMarkerColor(
  samplingClassificationId: number | null | undefined,
  colorsById: Record<number, string>
): string {
  if (samplingClassificationId == null) {
    return DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR;
  }
  return colorsById[samplingClassificationId] || DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR;
}
